import { render, staticRenderFns } from "./outletCategory.vue?vue&type=template&id=6e850922&scoped=true&"
import script from "./outletCategory.vue?vue&type=script&lang=js&"
export * from "./outletCategory.vue?vue&type=script&lang=js&"
import style0 from "./outletCategory.vue?vue&type=style&index=0&id=6e850922&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e850922",
  null
  
)

export default component.exports